import axios, { AxiosResponse } from 'axios';
import { isCenterViewMode } from '../lib/utils';

export /**
 * @method post
 * @brief 관리자 유저플로우 저장
 */
const storeUserFlow = async (
  event?: string | null,
  accessToken?:string
): Promise<any> => {
  // 열람 정책상 페이지별 조회 이력은 남기지 않고 세션 시작/종료만 기록한다.
  if (isCenterViewMode()) return { status: 204 };

  let response = {} as AxiosResponse<any, any>;
  try {
    response = await axios({
        method: 'post',
        url: `${process.env.REACT_APP_SERVER}/v1/adminUserflows`,
        headers: {authorization: accessToken},
        data: {
            event
        },
    });

    if (response.status === 200) {
        return response.data;
    }
  } catch (error: any) {
    // Error 😨
    switch (error.response.status) {
        case 401:
            return {status: error.response.status};
        case 403:
            return {status: error.response.status};
        case 500:
            alert('서버 내부 오류.');
        return {status: error.response.status};
    }
  }
};
